import React from 'react';
import PropTypes from 'prop-types';

const CardAction = ({
  shadowDistance = 1,
  title,
  info,
  action,
  image,
  imageWidth,
  width,
  className = '',
  style = {}
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `card-action shadow-${shadowDistance} ${className}`,
    style: {
      width,
      ...style
    }
  }, image && /*#__PURE__*/React.createElement("div", {
    className: "imageContainer"
  }, /*#__PURE__*/React.createElement("img", {
    src: image,
    style: {
      width: imageWidth || '100%'
    },
    alt: title
  })), /*#__PURE__*/React.createElement("div", {
    className: "card__body"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "card__title"
  }, title), info && /*#__PURE__*/React.createElement("div", {
    className: "card__info"
  }, info), action));
};

CardAction.propTypes = {
  action: PropTypes.element.isRequired,
  title: PropTypes.string,
  info: PropTypes.string,
  image: PropTypes.string,
  imageWidth: PropTypes.number,
  width: PropTypes.number,
  shadowDistance: PropTypes.oneOf([0, 1, 2, 3]),
  className: PropTypes.string,
  style: PropTypes.object
};
export default CardAction;